import { ApiCallError } from 'app/http/ApiCallError';

export const UPDATE_ACCOUNT_GENERIC_ERROR = 'Something went wrong :( \nPlease connect to administrator';

export const getUpdateAccountErrorMessage = (error: unknown): string => {
  if (!(error instanceof ApiCallError) || error.status === undefined || error.status >= 500) {
    return UPDATE_ACCOUNT_GENERIC_ERROR;
  }
  const body = error.body;
  if (typeof body !== 'object' || body === null || !('message' in body)) {
    return UPDATE_ACCOUNT_GENERIC_ERROR;
  }
  if (Array.isArray(body.message) && body.message.length > 0) {
    return body.message.join('\n');
  }
  if (typeof body.message === 'string' && body.message.trim() !== '') {
    return body.message;
  }
  return UPDATE_ACCOUNT_GENERIC_ERROR;
};
